<script>
import Feedbacks from "./Feedbacks";

export default {
  components: {
    Feedbacks
  },

  props: {
    bio: {
      required: true
    },
    isSelected: {
      required: true,
      type: Boolean
    },
    latestFeedback: {
      type: Object,
      require: false,
      default: null
    }
  }
};
</script>

<template>
  <div class="middle" @click.stop>
    <div v-if="latestFeedback && !isSelected" class="highlighted-feedback">
      <div>
        <p>
          "{{latestFeedback.description}}"
        </p>
      </div>

      <img src="/static/person.svg" class="profile_picture">
    </div>

    <div v-else class="biography-content" :class="{ 'full-biography': isSelected }">
      <h4>sobre o profissional:</h4>

      <p>
      {{ bio || "O profissional não possui uma biografia." }}
    </p>
    </div>

    <div class="actions" v-if="isSelected">
      <div class="feedbacks">
        Avaliações
      </div>
    </div>

    <div v-if="isSelected" class="feedback-content">
      <Feedbacks />
    </div>

  </div>
</template>

<style scoped>
.middle {
  position: relative;
  padding: 12px;
}

h4 {
  margin: 0;
  font-weight: 500;
}

.profile_picture {
  margin-left: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50px;
}

.highlighted-feedback {
  width: 100%;
  position: relative;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  flex-direction: row;
}
.highlighted-feedback > div {
  flex: 1;
  padding: 12px;
  background-color: #f2f2f2;
  border-top-left-radius: 12px;
  border-top-right-radius: 2px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.biography-content {
  width: 100%;
  position: relative;
  font-size: 12px;
  line-height: 16px;
  text-align: justify;
}

.highlighted-feedback p {
  margin: 0;
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-style: italic;
}

.biography-content > p {
  margin: 0;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.full-biography > p {
  -webkit-line-clamp: unset;
}

.actions {
  margin: 16px auto 8px;
  width: 100%;
  height: 1px;
  position: relative;
  background: #ddd;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.feedbacks {
  position: absolute;
  top: -7px;
  background: #fff;
  padding: 0 12px;
  font-size: 14px;
}

.feedbacks-content {
  width: 100%;
  position: relative;
  font-size: 12px;
  line-height: 16px;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Profile.vue